// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chinchou: PokeData = {
  "id": 170,
  "name": "chinchou",
  "height": 5,
  "weight": 120,
  "base_experience": 66,
  "types": [
    PokeType.WATER,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "take-down",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "thunder-wave",
    "confuse-ray",
    "bubble",
    "flail",
    "spark",
    "charge",
    "signal-beam",
    "aqua-ring",
    "discharge",
    "electro-ball",
    "ion-deluge"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "bubble-beam",
    "confuse-ray",
    "bubble",
    "rain-dance",
    "electric-terrain",
    "brine",
    "aqua-cutter",
    "thunder",
    "electric-wrath",
    "life-dew",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 86,
    "item": null,
    "species": [
      {
        "name": "chinchou",
        "order": 201,
        "types": [
          PokeType.WATER,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lanturn",
        "order": 202,
        "types": [
          PokeType.WATER,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 170,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61,
    "speed": 67,
    "ability_power": 56
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
